module.exports = __webpack_public_path__ + "static/media/ruleBanner.b4bf1e18.jpg";